import { Text, View } from '@react-pdf/renderer';

import { commentarySectionStyles, fontStyles } from '../styles.ts';

type CommentarySectionProps = {
  title: string;
  commentary?: string;
};

export const CommentarySection = ({ title, commentary }: CommentarySectionProps) => {
  if (!commentary) return null;

  return (
    <View>
      <View style={commentarySectionStyles.titleContainer}><Text style={fontStyles.h4}>{title}</Text></View>
      <Text style={fontStyles.body}>{commentary}</Text>
    </View>
  );
};

export const MultiCommentarySection = ({ sections }: { sections: CommentarySectionProps[] }) => {
  if (sections.every(({ commentary }) => !commentary)) return null;

  return (
    <View style={commentarySectionStyles.multiCommentarySection}>
      {sections.map(({ title, commentary }) => (
        <View key={title}>
          <Text style={fontStyles.h4}>{title}</Text>
          <Text style={fontStyles.body}>{commentary}</Text>
        </View>
      ))}
    </View>
  );
};
